import { Box, Grid, Typography } from "@mui/material";
import React from "react";
import Copyright from "../../internals/components/Copyright";
import WithdrawalRequest from "./WithdrawalRequest";

const WithdrawalRequestMain = ({ token, id, isAuthenticated, setIsAuthenticated }) => {
	return (
		<Box sx={{ width: "100%", maxWidth: { sm: "100%", md: "1700px" } }}>
			{/* cards */}
			<Typography component="h2" variant="h6" sx={{ mb: 2 }}>
				Customer Withdrawal Requests
			</Typography>
			<Grid container columns={12}>
				<Grid size={{ xs: 12, md: 12, lg: 12 }}>
					<WithdrawalRequest token={token} id={id} isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated} />
				</Grid>
			</Grid>
			<Copyright sx={{ my: 4 }} />
		</Box>
	);
};

export default WithdrawalRequestMain;
